// 初始化状态管理器 - 确保系统配置只初始化一次
class InitManager {
  constructor() {
    this.initialized = {
      departments: false,
      positions: false,
      tags: false,
      sources: false,
      ratings: false,
      onboardingTasks: false,
      employeeTaskTemplates: false
    };
    
    this.dataCache = {
      departments: null,
      positions: null,
      tags: null,
      sources: null,
      ratings: null,
      onboardingTasks: null,
      employeeTaskTemplates: null
    };
  }

  // 检查某个模块是否已初始化
  isInitialized(module) {
    return this.initialized[module] || false;
  }

  // 标记某个模块为已初始化
  setInitialized(module) {
    this.initialized[module] = true;
  }

  // 获取缓存的数据
  getCachedData(module) {
    return this.dataCache[module];
  }

  // 设置缓存的数据
  setCachedData(module, data) {
    this.dataCache[module] = data;
  }

  // 检查数据是否存在（非空数组）
  hasData(module) {
    const data = this.dataCache[module];
    return data && Array.isArray(data) && data.length > 0;
  }

  // 重置某个模块的初始化状态（用于强制刷新）
  resetModule(module) {
    this.initialized[module] = false;
    this.dataCache[module] = null;
  }

  // 重置所有模块的初始化状态
  resetAll() {
    Object.keys(this.initialized).forEach(module => {
      this.initialized[module] = false;
      this.dataCache[module] = null;
    });
  }
}

// 创建单例实例
const initManager = new InitManager();

export default initManager;
